<template>
    <div>

        <div class="picture">

            <img src="../assets/web.jpeg" alt="">
           
        </div>

        <div class="special-effect">
<ul class="i">
    <li>i.Write</li>
    <li>i.Learn</li>
    <li>i.Code</li>
</ul>
        </div>


        <div id="aboutid" class="about">

           
            <h1>About Me</h1>
            <p class="me">My name is Maryam Mudasiru.I am a junior frontend developer and a budding flutter developer. I am passionate about creating functional user interfaces that solve problems. I work well in a team and I make sure to execute all my tasks to the best of my ability.
</p> <a href="https://www.notion.so/Resume-77f647fed47f468bb7d985bd91990a88">
<button>LEARN MORE</button></a>

        </div>


        <div class="skills">
           
            <h1>SKILLS</h1>

            <p>      I have good working knowledge and experience in the use of my css and javascript skills to create amazing web technologies including;
    

</p>

<ul class="apps">

    <li>-Progressive Web Apps</li>
    <li>-Static Web Applications</li>
    <li>-Robust Web Applications</li>

</ul>
 

        </div>

        <div class="include">          
            
          

            <div class="lists">

                

                <v-card class="ml-2 active" style="width:30%;">

                <ul>

                    <h3>Web Basics</h3>
                    <li>HTML</li>
                    <li>Plain CSS</li>
                    <li>Vanilla JS</li>
                   
                </ul>

                </v-card>
               

                <v-card class="ml-1 active" style="width:30%;">

                <ul>
                    <h3>Frameworks</h3>
                    <li>Vue js.</li>
                    <li>Angular Js</li>
                    
                </ul>

                </v-card>

                <v-card class="ml-1 active" style="width:30%;">

                <ul>
                    <h3> Dev Tools</h3>
                    <li>Vscode</li>
                    <li> Version Control Systems</li>
                    <li>Node Package Manager  </li>
                </ul>

                </v-card>

                <v-card class="ml-1 mr-2 active" style="width:30%;">

                <ul>
                    <h3> Css Frameworks</h3>
                    <li>Vuetify</li>
                    <li>Bootstrap</li>
                </ul>
                </v-card>

             
</div>



</div>

 <!--  <div id="contactid" class="contact">
       <h2>Contact Me</h2>
     
                    <form  class="contact-me">
<label for="name">Name</label>
<br>
                        <input name="name" type="text">
                        <br>

                        <label for="email">Email</label>
                        <br>
                        <input type="email" name="email" id="">
                        <br>
<label for="message">Message</label>
<br>
<input type="text" class="area" name="message" id="">
            
                    </form>
                </div>-->
<div id="contactid" class="footer">
    <div class="names">
        Maryam Mudasiru-2020
    </div>

    <div class="socials">
     <a href="https://twitter.com/emsinachi?s=09">   <i class="fab fa-twitter"></i></a>
      <a style="color:white;" href="mailto:maryammudasiru@gmail.com" >  <i class="fas fa-envelope-open-text"></i></a>
       <a style="color:white;"  href="https://github.com/Adenikym/"> <i class="fab fa-github-square"></i></a>
    </div>
</div>
       
    </div>
</template>


<script>
export default {
    name:'Home',
    data() {
        return {
              icons: [
        
      ]
        }
    },
}
</script>


<style  scoped>

h1{
    color: #a800e0;
}

/* footer*/

.footer{
    display :flex;
    width:100%;
    background-color: #ac00ef ;
    color: white;
    align-items:center;
    height:60px;
}

.footer .names{
margin-left:5%;
}

.socials{
    display:flex;
    justify-content: space-around;
    width:30%;
    margin-left:18%;
}

.picture img{
    width:40%;
    margin-left:30%;
    margin-bottom:40px;
}

/*
.picture{
    width:35%;
   
    margin-left: 32%;
    margin-bottom: 20px;
    background-image: url("../assets/web.jpeg");
    background-size: cover;
    height: 450px;
}*/


.fas, .fab{
font-size: 1.5rem;
}
.special-effect{
    width:50%;
    border:1px solid purple;
    margin-left: 25%;
}

.i{
    list-style: none;
    display: flex;
    width:80%;
    margin-left: 10%;
}

.i li{
    font-size: 2rem;
    margin-left: 9%;
    
}

.about{
    width: 60%;
    margin-left: 5%;
    margin-top: 40px;
    margin-bottom: 10px;
}

.about h1{
    margin-top: 5px;
    margin-bottom: 20px;
    margin-left: 5%;
}

.about p{
    width:80%;
    margin-left: 5%;
    margin-bottom: 20px;
}

.about button{
    border: 1px solid #a800e0;
    padding: 5px 10px;
   border-radius: 5px;
   margin-left: 5%;
   
}

.skills{
    background-color: #9900cc;
    margin-bottom: 100px;
    color: white;
    height: 200px;
}

.apps{
    list-style: none;
    margin-bottom: 40px;
    
}

.lists{
    display: flex;
    position: absolute;
    width: 100%;
   
    top:870px;
}

.lists ul{
    list-style: none;
}

.contact{
    height: 400px;
    margin-left: 10%;
   
}

.contact input{
   
    margin-bottom: 20px;
    width:80%;
    border-radius: 10px;
    background-color: #f9efff ;
    height: 35px;

}

.contact label{
    margin-bottom: 5px;
}

.contact .area{
    height: 150px;
}

.contact h2{
    margin-left: 33%;
    color: #a800e0;
}

.skills h1{
    color:white;

    text-align: center;
}

.skills ul{
    display: flex;
    margin-left: 20%;
}

.skills ul li{
    margin-left: 5%;
}

.lists ul h3{color: #a800e0;}

.skills p{
text-align: center;
    width:60%;
    margin-left:20%;
}


/* start section*/


/* start section  ends*/

@media only screen and (max-width: 1125px){
    .about{
    width: 70%;
   
}

.lists{
    top:800px !important;
}


}

@media only screen and (max-width:576px){
     .about{
    width: 80%;
   margin-left: 10%;

}

.about h1{
    margin-top: 5px;
    margin-bottom: 20px;
    margin-left: 28%;
}

.about p{
    width:90%;
    margin-left: 5%;
    margin-bottom: 20px;
    text-align: center;
    
}


.about button{
    border: 1px solid #a800e0;
   
   margin-left: 40%;
   
}



.lists .active ul{
   margin-right: 4%;
    text-align: center;
  
}

.lists .active .ul h3{
    margin-top: 20px !important;
}


.lists .active{
    width: 60% !important;
    margin-left: 20% !important;
    height: 150px;
    margin-bottom: 20px;
}

.footer .names{
margin-left:5%;
width:50%;
}

.socials{
    display:flex;
    justify-content: space-around;
    width:30%;
    margin-left:10%;
}
}


/* special section begins*/

@media only screen and (max-width: 920px){
.special-effect{
    width:60%;
   
    margin-left: 20%;
}

.i{
    
    width:80%;
    margin-left: 10%;
}

.i li{
    margin-left: 6%;
}
}

@media only screen and (max-width: 768px){
   .special-effect{
    width:80%;
   
    margin-left: 10%;
}
}

@media only screen and (max-width: 576px){
    .about button{
        margin-left: 30%;
        margin-bottom: 10px;
    }

     .special-effect{
   width: 80%;
   margin-left: 5%;
}

.special-effect .i li{
font-size: 1.5rem;
}

 .special-effect{
    width:80%;
   
    margin-left: 10%;
}

.i li{
 margin-left: 5%;
}

.picture{
     margin-top: 30px;
}

.picture img{
    width:70%;
     margin-left: 15%;
    

}

}

@media only screen and (max-width: 400px){
    .special-effect{
    width:90%;
   
    margin-left: 5%;
}

.i li{
 margin-left: 1%;
}


}
/* special section ends*/


/* skills section begins*/
@media only screen and (max-width: 1125px){
    .skills ul li{
        margin-left: 2%;
    }

    

    .skills h1{
    color:white;

    text-align: center;
}

.skills ul{
   
    margin-left: 12%;
}

.skills ul li{
    margin-left: 5%;
}

.skills p{
    width:70%;
    margin-left:12%;
}


}

/*1125 ends*/

@media only screen and (max-width: 920px){
 .lists{
        top: 780px;
    }
}

@media only screen and (max-width: 768px){
.lists{
        top: 805px !important;
    }

    .skills .apps{
   margin-left: 4%;
}
}

@media only screen and (max-width: 576px){
.lists{
position: static;
display: block;

}

.skills{
    height: 300px;
    margin-bottom: 20px;
}


.contact h2{
    margin-left: 23%;
  
}

.skills .apps{
   margin-left: 24%;
   display:block;
  
}



}

@media only screen and (max-width:400px){
.skills .apps{
   margin-left: 14%;
   width:100%;
  
  
}
}
/* skills section ends*/

/*contact sevtion begins*/
@media only screen and (max-width: 768px){
.contact{
    margin-top: 100px;}
}
/*contact sevtion ends*/


</style>